import React from 'react';
import { Container } from 'react-bootstrap';
import { ProjectCard } from './ProjectCard';
import space from '../assets/img/space.png';
import docAppointment from '../assets/img/docAppointment.png';
import qrShops from '../assets/img/qrshop.png';
import env from '../assets/img/schoolManager.png';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
  const projects = [
    {
      title: "Language School Management System",
      language: ["React", "TypeScript", "Java", "Spring Boot", "Spring Data JPA", "PostgreSQL", "Flyway", "Docker"],
      imgUrl: env,
      description:
        "A full-stack application designed to manage school infrastructures, user roles, and educational content. Features structured schema migrations and isolated database containerization alongside a responsive client dashboard to handle resource allocations for schools, lessons, and multi-tier course levels.",
      demoLogin: {
        role: "Admin",
        email: "admin245@example.com",
        password: "Demo@12345",
        note: "Use this demo account to explore the admin dashboard with sample school data.",
      },
      live: "https://school-frontend-e8oa.onrender.com/",
      source: "https://github.com/MayPyone/school-frontend",
    },
    {
      title: "QR Shops",
      language: ["React", "TypeScript", "Kotlin", "Quarkus", "PostgreSQL", "Tailwind CSS", "Playwright"],
      imgUrl: qrShops,
      description:
        "A scalable retail platform featuring back-office services for complete shop management. Built to handle RESTful service operations, structured data models, store detail updates, custom categories, catalog management, and an integrated image upload gallery system.",
      live: "https://platform.acfsoft.com/login",
      source: "https://platform.acfsoft.com/login",
    },
    {
      title: "Doctor Appointment",
      language: ["React", "Node.js", "Express", "MongoDB"],
      imgUrl: docAppointment,
      description:
        "A full-stack medical appointment management platform. Includes hassle-free appointment scheduling, cancellations, online payments, and dedicated role-based dashboards tailored for admins, doctors, and patients.",
      live: "https://prescripto-doctors-appointment.onrender.com/",
      source: "https://github.com/MayPyone/Doctors-appointment/tree/dev",
    },
    {
      title: "Space Traveller's Hub",
      language: ["JavaScript", "React", "REST API"],
      imgUrl: space,
      description:
        "A collaborative web application connected to live SpaceX data. Users can browse active space missions, reserve rockets, and join official space travel programs through a real-time, interactive interface.",
      live: "https://spacetravellerteam.netlify.app",
      source: "https://github.com/MayPyone/space-travelers-hub",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <TrackVisibility>
          <div className="placed-card">
            <h2>Pro<span className="underline">jec</span>ts</h2>
            <div className="project-list">
              {projects.map((project, index) => (
                <ProjectCard
                  key={project.title}
                  title={project.title}
                  language={project.language}
                  imgUrl={project.imgUrl}
                  description={project.description}
                  demoLogin={project.demoLogin}
                  live={project.live}
                  source={project.source}
                  reverse={index % 2 === 1}
                />
              ))}
            </div>
          </div>
        </TrackVisibility>
      </Container>
    </section>
  );
};
